import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';
import '../styles/AdminLoginPage.css';

const AdminLoginPage: React.FC = () => {
  const { admin, loading, error, loginAdmin } = useAdminAuth();
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [loginError, setLoginError] = useState<string | null>(null);
  const history = useHistory();
  const location = useLocation();
  
  // If user is already logged in as admin, redirect to dashboard
  useEffect(() => {
    if (admin && !loading) {
      console.log('AdminLoginPage: User is already logged in, redirecting to dashboard');
      console.log('Admin user data:', admin);
      const { from = { pathname: '/admin/dashboard' } } = (location.state as { from?: { pathname: string } }) || {};
      history.replace(from);
    }
  }, [admin, loading, history, location]);
  
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoginError(null);
    
    if (!email || !password) {
      setLoginError('Please enter both email and password');
      return;
    }
    
    console.log('Submitting login form...', { email });
    const success = await loginAdmin(email, password);
    console.log('Login attempt result:', success, 'Error:', error);
    
    if (success) {
      console.log('Login successful, redirecting to dashboard...');
      history.push('/admin/dashboard');
    } else {
      console.log('Login failed, showing error:', error);
      setLoginError(error || 'Login failed. Please check your credentials.');
    }
  };
  
  return (
    <div className="admin-login-page">
      <div className="admin-login-container">
        <div className="admin-login-header">
          <img src="/assets/default-logo.jpg" alt="Clipo Logo" className="admin-logo" />
          <h1>Admin Portal</h1>
          <p>Login to access the admin dashboard</p>
        </div>
        
        <form onSubmit={handleSubmit} className="admin-login-form">
          {loginError && <div className="admin-login-error">{loginError}</div>}
          
          <div className="admin-form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@example.com"
              required
            />
          </div>
          
          <div className="admin-form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>
          
          <button 
            type="submit" 
            className="admin-login-button" 
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLoginPage;